// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file pcf_bundled_settings_service.proto (package pipeex.pcf.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { PcfSettingsDto } from "./pcf_export_service_pb";
import { file_pcf_export_service } from "./pcf_export_service_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pcf_bundled_settings_service.proto.
 */
export const file_pcf_bundled_settings_service: GenFile = /*@__PURE__*/
  fileDesc("CiJwY2ZfYnVuZGxlZF9zZXR0aW5nc19zZXJ2aWNlLnByb3RvEg1waXBlZXgucGNmLnYxIh0KG1JlYWRCdW5kbGVkUGNmQ29uZmlnUmVxdWVzdCJyChxSZWFkQnVuZGxlZFBjZkNvbmZpZ1Jlc3BvbnNlEhIKCmlzX3N1Y2Nlc3MYASABKAgSDQoFZXJyb3IYAiABKAkSLwoIc2V0dGluZ3MYAyABKAsyHS5waXBlZXgucGNmLnYxLlBjZlNldHRpbmdzRHRvMowBChlQY2ZCdW5kbGVkU2V0dGluZ3NTZXJ2aWNlEm8KFFJlYWRCdW5kbGVkUGNmQ29uZmlnEioucGlwZWV4LnBjZi52MS5SZWFkQnVuZGxlZFBjZkNvbmZpZ1JlcXVlc3QaKy5waXBlZXgucGNmLnYxLlJlYWRCdW5kbGVkUGNmQ29uZmlnUmVzcG9uc2VCEKoCDVBpcGVlWC5Qcm90b3NiBnByb3RvMw", [file_pcf_export_service]);

/**
 * @generated from message pipeex.pcf.v1.ReadBundledPcfConfigRequest
 */
export type ReadBundledPcfConfigRequest = Message<"pipeex.pcf.v1.ReadBundledPcfConfigRequest"> & {
};

/**
 * Describes the message pipeex.pcf.v1.ReadBundledPcfConfigRequest.
 * Use `create(ReadBundledPcfConfigRequestSchema)` to create a new message.
 */
export const ReadBundledPcfConfigRequestSchema: GenMessage<ReadBundledPcfConfigRequest> = /*@__PURE__*/
  messageDesc(file_pcf_bundled_settings_service, 0);

/**
 * @generated from message pipeex.pcf.v1.ReadBundledPcfConfigResponse
 */
export type ReadBundledPcfConfigResponse = Message<"pipeex.pcf.v1.ReadBundledPcfConfigResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: pipeex.pcf.v1.PcfSettingsDto settings = 3;
   */
  settings?: PcfSettingsDto | undefined;
};

/**
 * Describes the message pipeex.pcf.v1.ReadBundledPcfConfigResponse.
 * Use `create(ReadBundledPcfConfigResponseSchema)` to create a new message.
 */
export const ReadBundledPcfConfigResponseSchema: GenMessage<ReadBundledPcfConfigResponse> = /*@__PURE__*/
  messageDesc(file_pcf_bundled_settings_service, 1);

/**
 * Reads the plugin-bundled PcfConfig JSON files shipped in the plugin bundle.
 * Used by the welcome page "Convert current settings" flow to create a
 * reusable profile from the local PcfConfig defaults.
 *
 * @generated from service pipeex.pcf.v1.PcfBundledSettingsService
 */
export const PcfBundledSettingsService: GenService<{
  /**
   * Read the five bundled PcfConfig JSON files (AdvancedSettings, AllTags,
   * BomParameters, IsoParameters, ValidationMap) from the plugin's PcfConfig
   * directory on disk. No Revit thread dependency — pure file I/O.
   *
   * @generated from rpc pipeex.pcf.v1.PcfBundledSettingsService.ReadBundledPcfConfig
   */
  readBundledPcfConfig: {
    methodKind: "unary";
    input: typeof ReadBundledPcfConfigRequestSchema;
    output: typeof ReadBundledPcfConfigResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_pcf_bundled_settings_service, 0);

